import Reflux from "reflux";
import { Users } from "@graylog/server-api";
import { singletonStore } from "logic/singleton";
import { SessionActions, SessionStore } from "stores/sessions/SessionStore";
export const CurrentUserStore = singletonStore(
  "core.CurrentUser",
  () => Reflux.createStore({
    listenables: [SessionActions],
    currentUser: void 0,
    init() {
      this.listenTo(SessionStore, this.sessionUpdate, this.sessionUpdate);
    },
    getInitialState() {
      return { currentUser: this.currentUser };
    },
    get() {
      return this.currentUser;
    },
    sessionUpdate(sessionInfo) {
      if (sessionInfo.username) {
        const { username } = sessionInfo;
        this.update(username);
      } else {
        this.currentUser = void 0;
        this.trigger({ currentUser: this.currentUser });
      }
    },
    reload() {
      if (this.currentUser !== void 0) {
        return this.update(this.currentUser.username);
      }
      return Promise.resolve();
    },
    update(username) {
      return Users.get(encodeURIComponent(username)).then((resp) => {
        this.currentUser = resp;
        this.trigger({ currentUser: this.currentUser });
        return resp;
      });
    }
  })
);
